<odx-modal-header>
  <odx-area-header i18n="@@modal.projectVersion.header">Projekt exportieren</odx-area-header>
</odx-modal-header>

<odx-modal-content>
  <p i18n="@@modal.projectVersion.header.checkVersion">Bitte überprüfen Sie die Versionsnummer vor dem Export.</p>

  <form odxForm [formGroup]="projectVersionForm" class="form">
    <odx-form-field i18n-label="@@modal.projectVersion.label.projectVersion" label="Version">
      <input
        type="text"
        formControlName="version"
        odxFormFieldControl
        i18n-placeholder="@@modal.projectVersion.placeholder.projectVersion"
        placeholder="Version"
        data-testid="modal.projectVersion"
      />
    </odx-form-field>
  </form>
  <div class="checkboxes">
    <odx-checkbox [(checked)]="isRiskAssessmentIncluded" i18n="@@pdf.includeRiskAssessment">
      Risikobewertung im PDF enthalten
    </odx-checkbox>
    @if (isMonitoringScope) {
      <odx-checkbox [(checked)]="isSignOffPageIncluded" i18n="@@pdf.includeSignOffPage">
        Include sign-off page in PDF
      </odx-checkbox>
    }
  </div>
</odx-modal-content>
<odx-modal-footer>
  <button odxButton variant="secondary" odxModalDismiss i18n="@@global.dismiss">Abbrechen</button>
  <button
    odxButton
    odxModalClose
    variant="primary"
    (click)="onConfirm()"
    i18n="@@modal.projectVersion.button.export"
    data-testid="modal.projectVersion.button.export"
  >
    Exportieren
  </button>
</odx-modal-footer>
